import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PrivateHealthIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        clipRule="evenodd"
        d="M14.033 3.352a.848.848 0 01.946-.735c.825.103 1.78.658 2.592 1.519.834.883 1.578 2.15 1.944 3.799.205.928.164 2.041.006 3.174-.16 1.146-.452 2.379-.792 3.576-.68 2.396-1.577 4.717-2.094 6.03a.847.847 0 11-1.577-.62c.514-1.307 1.385-3.563 2.04-5.873.329-1.154.598-2.306.744-3.348.148-1.056.16-1.934.018-2.572-.3-1.349-.897-2.341-1.522-3.003-.646-.686-1.265-.963-1.57-1a.848.848 0 01-.735-.947m-7.944 0a.847.847 0 00-.946-.735c-.826.103-1.782.658-2.593 1.519-.834.883-1.578 2.15-1.943 3.799C.4 8.863.442 9.976.6 11.109c.16 1.146.451 2.379.791 3.576.68 2.396 1.577 4.717 2.094 6.03a.847.847 0 101.577-.62c-.514-1.307-1.384-3.563-2.04-5.873-.328-1.154-.598-2.306-.744-3.348-.148-1.056-.159-1.934-.018-2.572.3-1.349.897-2.341 1.522-3.003.647-.686 1.265-.963 1.57-1a.847.847 0 00.736-.947"
        fill="#000000"
        className={styles.defaultColor}
        fillRule="evenodd"
      ></path>
      <path
        clipRule="evenodd"
        d="M15.948 3.607a1.843 1.843 0 11-3.685.08 1.843 1.843 0 013.685-.08m-11.802 0a1.844 1.844 0 103.688.079 1.844 1.844 0 00-3.688-.08m-.06 14.902c.936 0 1.695.758 1.695 1.694a4.267 4.267 0 008.533 0 1.695 1.695 0 013.39 0 7.657 7.657 0 01-15.313 0c0-.936.759-1.695 1.695-1.695"
        fill="#000000"
        className={styles.defaultColor}
        fillRule="evenodd"
      ></path>
      <path
        d="M49.533 27.859c0 11.233-9.106 20.339-20.339 20.339-11.233 0-20.339-9.106-20.339-20.34 0-.64.03-1.272.088-1.897l1.688.151c-.053.575-.08 1.158-.08 1.747 0 10.297 8.347 18.644 18.643 18.644 10.297 0 18.644-8.347 18.644-18.644 0-4.724-1.757-9.038-4.653-12.323l1.253-1.143a20.262 20.262 0 015.095 13.466"
        fill="#000000"
        className={styles.defaultColor}
      ></path>
      <path
        clipRule="evenodd"
        d="M45.452 11.72a4.794 4.794 0 11-9.588 0 4.794 4.794 0 019.588 0"
        fill="#ffffff"
        className={styles.white}
        fillRule="evenodd"
      ></path>
      <path
        clipRule="evenodd"
        d="M40.658 7.774a3.947 3.947 0 100 7.893 3.947 3.947 0 000-7.893M38.5 6.508a5.642 5.642 0 114.318 10.425A5.642 5.642 0 0138.5 6.508"
        fill="#000000"
        className={styles.defaultColor}
        fillRule="evenodd"
      ></path>
      <path
        clipRule="evenodd"
        d="M38.814 11.72a1.845 1.845 0 103.69.078 1.845 1.845 0 00-3.69-.078"
        fill="#E81C30"
        className={styles.accentColor}
        fillRule="evenodd"
      ></path>
      <path
        d="M29.909 18.559s-4.785 4.385-10.366 3.19c0 0-1.197 14.351 10.365 19.534h-.034c11.56-5.183 10.364-19.535 10.364-19.535-5.581 1.196-10.364-3.19-10.364-3.19"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      ></path>
      <path
        clipRule="evenodd"
        d="M29.924 18.553s-4.784 4.386-10.366 3.19c0 0-1.196 14.352 10.366 19.535h-.034c11.56-5.183 10.364-19.535 10.364-19.535-5.581 1.196-10.364-3.19-10.364-3.19"
        fill="#ffffff"
        className={styles.white}
        fillRule="evenodd"
      ></path>
      <path
        clipRule="evenodd"
        d="M29.594 23.373c.936 0 1.695.759 1.695 1.695v2.731h2.731a1.695 1.695 0 010 3.39h-2.73v2.73a1.695 1.695 0 11-3.39 0v-2.73h-2.73a1.695 1.695 0 110-3.39h2.73v-2.731c0-.936.759-1.695 1.695-1.695"
        fill="#E81C30"
        className={styles.accentColor}
        fillRule="evenodd"
      ></path>
    </Icon>
  )
}
